import { render, staticRenderFns } from "./DashboardGroupConsent.vue?vue&type=template&id=fef171a0&scoped=true&"
import script from "./DashboardGroupConsent.vue?vue&type=script&lang=js&"
export * from "./DashboardGroupConsent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGroupConsent.vue?vue&type=style&index=0&id=fef171a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef171a0",
  null
  
)

export default component.exports